import type { DynamicFieldFormula } from '@atlassian/jira-polaris-domain-field/src/formula/types.tsx';
import {
	LINKED_ISSUES_TEMPLATE,
	type LinkedIssuesFormula,
} from '@atlassian/jira-polaris-domain-field/src/formula/linked-issues/types.tsx';

export const isLinkedIssuesFormula = (
	formula: DynamicFieldFormula,
): formula is LinkedIssuesFormula => formula.template === LINKED_ISSUES_TEMPLATE;
